module.exports = __webpack_public_path__ + "static/media/channellogo.624043dc.jpeg";